import { db, isFirebaseConfigured } from '../config/firebase';
import { doc, onSnapshot, serverTimestamp, setDoc } from 'firebase/firestore';

const defaultContent = () => ({
  announcement: {
    enabled: false,
    text: '',
    link: '',
  },
  newsletter: {
    title: 'STAY IN THE LOOP',
    subtitle: 'Be the first to know about new arrivals, exclusive offers, and more.',
  },
  updatedAt: new Date().toISOString(),
});

const normalizeContent = (c) => {
  const base = defaultContent();
  if (!c || typeof c !== 'object') return base;

  const a = c.announcement && typeof c.announcement === 'object' ? c.announcement : {};
  const n = c.newsletter && typeof c.newsletter === 'object' ? c.newsletter : {};

  return {
    announcement: {
      enabled: Boolean(a.enabled),
      text: String(a.text || ''),
      link: String(a.link || ''),
    },
    newsletter: {
      title: String(n.title || base.newsletter.title),
      subtitle: String(n.subtitle || base.newsletter.subtitle),
    },
    updatedAt: String(c.updatedAt || base.updatedAt),
  };
};

const emitChanged = () => {
  try {
    window.dispatchEvent(new Event('ditris:siteContent'));
  } catch {
    // ignore
  }
};

let cached = defaultContent();
let started = false;
let unsub = null;

const startSync = () => {
  if (started) return;
  started = true;
  if (!isFirebaseConfigured || !db) return;

  try {
    const ref = doc(db, 'siteContent', 'global');
    unsub = onSnapshot(
      ref,
      (snap) => {
        try {
          cached = normalizeContent(snap.exists() ? snap.data() : null);
          emitChanged();
        } catch {
          // ignore
        }
      },
      () => {
        // ignore
      }
    );
  } catch {
    // ignore
  }
};

export const getSiteContent = () => {
  startSync();
  return normalizeContent(cached);
};

export const setSiteContent = (content) => {
  const next = normalizeContent({
    ...content,
    updatedAt: new Date().toISOString(),
  });
  cached = next;
  emitChanged();

  if (isFirebaseConfigured && db) {
    setDoc(
      doc(db, 'siteContent', 'global'),
      {
        ...next,
        updatedAt: serverTimestamp(),
      },
      { merge: true }
    );
  }
  return next;
};

export const patchSiteContent = (patch) => {
  const current = getSiteContent();
  return setSiteContent({
    ...current,
    ...patch,
    announcement: {
      ...current.announcement,
      ...(patch?.announcement || {}),
    },
    newsletter: {
      ...current.newsletter,
      ...(patch?.newsletter || {}),
    },
  });
};
